import { Navigate } from "react-router-dom";
import React, { useState,useEffect } from "react";


const ProtectedRoute = ({ children }) => {
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const isLoggedInFlag = localStorage.getItem("isLoggedIn") === "true";
    setIsLoggedIn(isLoggedInFlag);
    setIsAuthChecked(true); // 로그인 여부 확인 완료
  }, []);

  if (!isAuthChecked) {
    return null; // 또는 로딩 중 표시
  }

  return isLoggedIn ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;